import { TranslateService } from '@ngx-translate/core';
import { DialogObject } from '../../../../components/dialog/dialog.types';
import { RefParamRepository } from '../../../../store/ref-param-state/ref-param-state.repository';

interface getRefParamsDeleteObjectProps {
  t: TranslateService;
  store?: RefParamRepository;
  representation?: string | number;
  action: () => void;
  toggleVisiblity?: () => void;
}

export const getRefParamsDeleteObject = ({ t, store, representation, action, toggleVisiblity }: getRefParamsDeleteObjectProps): DialogObject => {
  return {
    title: t.instant(`settings.refParams.deleteConfirm`, {
      representation: representation,
    }),
    description: '',
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'Supprimer',
        variant: 'danger',
        onClick: () => action?.(),
      },
      {
        label: 'Annuler',
        onClick: () => {
          toggleVisiblity?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
